import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Alert,
  Spinner
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import classnames from "classnames";
import axios from 'axios'; // Axios import edildi
import toastr from 'toastr'; 
import 'toastr/build/toastr.min.css'; 

// --- API YAPILANDIRMASI ---
const API_URL = "https://dlaviapi.stechomeyazilim.info/App_Page_Content";

// Kategori Başlıkları Sözlüğü
const PAGE_CODE_LABELS = {
  "WHY_DLAVIA": "Neden DLAvia?",
  "PRIVACY": "Gizlilik Politikası",
  "EXAM_INFO": "Sınav Bilgileri",
  "CONTACT": "İletişim",
  "CONTACT_NOTE": "Dipnotlar",
  "INVITE": "Davet Alanı"
};

const PageContentManager = () => {
  document.title = "Uygulama İçerik Yönetimi | DLApro Paneli";

  // State Yönetimi
  const [localContent, setLocalContent] = useState([]);
  const [activeTab, setActiveTab] = useState("WHY_DLAVIA");
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  // --- VERİ ÇEKME (FETCH) ---
  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(API_URL);
      
      // API dönüş yapısına göre veriyi yakalama
      // Olası yapılar: res.data, res.data.value, veya res.data.App_Page_Content
      let data = [];
      if (response.data && Array.isArray(response.data)) {
          data = response.data;
      } else if (response.data?.value && Array.isArray(response.data.value)) {
          data = response.data.value; // OData formatı
      } else if (response.data?.App_Page_Content && Array.isArray(response.data.App_Page_Content)) {
          data = response.data.App_Page_Content; // Özel JSON formatı
      }

      // Sıralama (Sort_Order'a göre)
      const sortedList = data.sort((a, b) => a.Sort_Order - b.Sort_Order);
      setLocalContent(sortedList);

      // İlk tabı otomatik seç (eğer veri varsa ve mevcut tab boşsa)
      if (sortedList.length > 0 && !activeTab) {
          setActiveTab(sortedList[0].Page_Code);
      }

    } catch (error) {
      console.error("Veri çekme hatası:", error);
      showToast(false, "Veriler sunucudan çekilemedi.");
    } finally {
      setIsLoading(false);
    }
  };

  // --- GÜNCELLEME (UPDATE) ---
  const handleUpdateItem = async (item) => {
    setIsUpdating(true);
    
    // API'nin beklediği payload yapısı
    const payload = {
        ID: item.ID,
        Page_Code: item.Page_Code,
        Title_TR: item.Title_TR,
        Title_EN: item.Title_EN,
        Description_TR: item.Description_TR,
        Description_EN: item.Description_EN,
        Image_Url: item.Image_Url,
        Sort_Order: item.Sort_Order
    };

    try {
        // Backend yapınıza göre PUT veya POST olabilir.
        // Genellikle güncelleme için ID URL'e eklenir veya body'de gönderilir.
        // Örnek: axios.post(`${API_URL}/Update`, payload) veya direkt URL
        
        await axios.post(API_URL, payload); // Endpoint'i backend yapınıza göre güncelleyin
        
        showToast(true, "Kayıt başarıyla güncellendi.");
        // Güncel hali tekrar çekmek isterseniz:
        // fetchContent(); 
    } catch (error) {
        console.error("Güncelleme hatası:", error);
        showToast(false, "Güncelleme sırasında hata oluştu.");
    } finally {
        setIsUpdating(false);
    }
  };

  // Input Değişikliklerini Yönetme (Local State)
  const handleInputChange = (id, field, value) => {
    setLocalContent(prevList => 
      prevList.map(item => 
        item.ID === id ? { ...item, [field]: value } : item
      )
    );
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const showToast = (isSuccess, msg) => {
    toastr.options = { positionClass: "toast-top-right", timeOut: 3000 };
    if (isSuccess) toastr.success(msg, "Başarılı");
    else toastr.error(msg, "Hata");
  };

  // Unique Tab Listesi
  const availableTabs = localContent.length > 0 
    ? [...new Set(localContent.map(item => item.Page_Code))] 
    : Object.keys(PAGE_CODE_LABELS); // Veri yoksa varsayılanları göster

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Uygulama İçerik Yönetimi" />

          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  
                  {isLoading ? (
                    <div className="text-center py-5">
                        <Spinner color="primary" />
                        <p className="mt-2">Veriler Yükleniyor...</p>
                    </div>
                  ) : (
                    <>
                      {/* SEKMELER */}
                      <Nav tabs className="nav-tabs-custom mb-4">
                        {availableTabs.map((code) => (
                          <NavItem key={code}>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({ active: activeTab === code })}
                              onClick={() => toggleTab(code)}
                            >
                              {PAGE_CODE_LABELS[code] || code}
                            </NavLink>
                          </NavItem>
                        ))}
                      </Nav>

                      {/* İÇERİK */}
                      <TabContent activeTab={activeTab}>
                        {availableTabs.map((code) => (
                          <TabPane tabId={code} key={code}>
                            <div className="d-flex flex-column gap-4">
                              {localContent
                                .filter(item => item.Page_Code === code)
                                .map((item) => (
                                  <Card key={item.ID} className="border shadow-sm bg-light mb-0">
                                    <CardBody>
                                      <Row>
                                        <Col md={1} className="d-flex align-items-center justify-content-center bg-white border-end rounded-start">
                                            <h3 className="text-secondary mb-0">#{item.Sort_Order}</h3>
                                        </Col>
                                        <Col md={11}>
                                            <Row className="mb-3 mt-2">
                                                <Col md={6}>
                                                    <Label className="fw-bold text-primary">Başlık (TR)</Label>
                                                    <Input 
                                                        type="text" 
                                                        value={item.Title_TR || ""} 
                                                        onChange={(e) => handleInputChange(item.ID, 'Title_TR', e.target.value)}
                                                    />
                                                </Col>
                                                <Col md={6}>
                                                    <Label className="fw-bold text-success">Title (EN)</Label>
                                                    <Input 
                                                        type="text" 
                                                        value={item.Title_EN || ""} 
                                                        onChange={(e) => handleInputChange(item.ID, 'Title_EN', e.target.value)}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col md={6}>
                                                    <Label>Açıklama (TR)</Label>
                                                    <Input 
                                                        type="textarea" 
                                                        rows="3"
                                                        value={item.Description_TR || ""} 
                                                        onChange={(e) => handleInputChange(item.ID, 'Description_TR', e.target.value)}
                                                    />
                                                </Col>
                                                <Col md={6}>
                                                    <Label>Description (EN)</Label>
                                                    <Input 
                                                        type="textarea" 
                                                        rows="3"
                                                        value={item.Description_EN || ""} 
                                                        onChange={(e) => handleInputChange(item.ID, 'Description_EN', e.target.value)}
                                                    />
                                                </Col>
                                            </Row>
                                            
                                            {/* Image URL alanı (Gerekirse açılabilir) */}
                                            {/* <Row className="mb-3">
                                                <Col md={12}>
                                                    <Label>Görsel URL</Label>
                                                    <Input 
                                                        type="text" 
                                                        value={item.Image_Url || ""} 
                                                        onChange={(e) => handleInputChange(item.ID, 'Image_Url', e.target.value)}
                                                    />
                                                </Col>
                                            </Row> 
                                            */}

                                            <div className="d-flex justify-content-end border-top pt-3">
                                                <Button 
                                                    color="primary" 
                                                    disabled={isUpdating}
                                                    onClick={() => handleUpdateItem(item)}
                                                >
                                                    {isUpdating ? <Spinner size="sm"/> : <i className="mdi mdi-content-save me-1"></i>}
                                                    Bu Kaydı Güncelle
                                                </Button>
                                            </div>
                                        </Col>
                                      </Row>
                                    </CardBody>
                                  </Card>
                                ))}
                            </div>
                            
                            {localContent.filter(item => item.Page_Code === code).length === 0 && (
                                <Alert color="warning" className="mt-3">Bu kategoride henüz içerik bulunamadı.</Alert>
                            )}

                          </TabPane>
                        ))}
                      </TabContent>
                    </>
                  )}

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PageContentManager;